import { render, staticRenderFns } from "./GridTechLevel.vue?vue&type=template&id=65615775&"
import script from "./GridTechLevel.vue?vue&type=script&lang=js&"
export * from "./GridTechLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports